module.exports = __webpack_public_path__ + "img/Los-Mochis-1.d886433d.jpeg";